<div class="userMenu_container">
  <button
    class="userMenu_button"
    aria-label="open user menu"
    aria-haspopup="true"
    (click)="toggleUserMenu()"
  >
    <app-user-avatar
      [firstName]="currentUser.userData.firstName"
      [lastName]="currentUser.userData.lastName"
      [fullName]="currentUser.userFullName"
      [avatar]="currentUser.userAvatar"
      [size]="'medium'"
    ></app-user-avatar>
  </button>

  @if (openMenu) {
    <ul
      class="userMenu_list"
      role="menu"
    >
      <li class="currentUserInfo" *blockUI="'account-menu-ui'">
        <div>
          @if (canShowMenu.editUserProfile) {
            <a [routerLink]="['/account']"
               (click)="toggleUserMenu()"
               aria-label="go to user settings"
               class="accountManagementLink currentRoleDetails"
            >
              <div class="userAvatar">
                <app-user-avatar
                  [firstName]="currentUser.userData.firstName"
                  [lastName]="currentUser.userData.lastName"
                  [fullName]="currentUser.userFullName"
                  [avatar]="currentUser.userAvatar"
                  [size]="'extralarge'"
                ></app-user-avatar>
              </div>
              <div class="userInfoIn">
                <div class="userName pageTitle">{{ currentUser.userFullName }}</div>
                <div class="userTitle pageHeader">
                  {{ currentUser.userData.email }}
                </div>
                <div class="userOrganization pageHeader">{{ currentUser.userData.organization.name }}</div>
              </div>

              @if (userIsActingAsEvaluatorForAccreditor) {
                <div class="weaveGrid orgInfoHeader evaluatorRole">
                  <figure class="institutionLogoContainer">
                    @if (currentEvaluatorRole.accreditor.thumbnail) {
                    <img
                      [src]="currentEvaluatorRole.accreditor.thumbnail"
                      [alt]="currentEvaluatorRole.accreditor.name"
                      class="institutionLogo">
                    } @else {
                     <mat-icon fontSet="material-icons-outlined">account_balance</mat-icon>
                    }
                  </figure>
                  <div class="organizationInfo">
                    @if (currentEvaluatorRole.role) {
                      <div class="userTitle">{{ currentEvaluatorRole.role }}</div>
                    }
                    <div class="accreditorName">{{ currentEvaluatorRole.accreditor.abbreviation }}</div>
                    <div class="programName">{{ currentEvaluatorRole.institutionName }}
                      - {{ currentEvaluatorRole.program.name }}
                    </div>
                  </div>
                </div>
              }
            </a>
          }
        </div>
      </li>



      @if (canShowMenu.settings) {
        <li routerLinkActive="active" class="withPadding">
          <a routerLink="/settings/overview" (click)="toggleUserMenu()">
            <mat-icon fontSet="material-icons-outlined">settings</mat-icon>
            <span class="pageHeader">Settings</span>
          </a>
        </li>
      }
      @if (canShowMenu.editUsersTab) {
        <li routerLinkActive="active" class="withPadding">
          <a routerLink="/users">
            <mat-icon fontSet="material-icons-outlined">groups</mat-icon>
            <span class="pageHeader">Users</span>
          </a>
        </li>
      }
      <!-- //this is for Stacey Rowand from CAHME -->
      @if (canShowMenu.manageStandardsAsAccreditor) {
        <li routerLinkActive="active" class="withPadding">
          <a routerLink="/accreditation/manage-standards">
            <mat-icon fontSet="material-icons-outlined">settings</mat-icon>
            <span class="pageHeader">Manage Standards</span>
          </a>
        </li>
      }
      <!-- //this is for Stacey Rowand from CAHME -->
      @if (canShowMenu.manageProgramTemplatesAsAccreditor) {
        <li routerLinkActive="active" class="withPadding">
          <a routerLink="/admin-tools/program-template/select-program-details-step">
            <mat-icon fontSet="material-icons-outlined">settings</mat-icon>
            <span class="pageHeader">Manage Templates</span>
          </a>
        </li>
      }
      @if (canShowMenu.otherRoles) {
        <li class="withPadding">
          <app-user-roles></app-user-roles>
        </li>
      }
      <!--
      <li class="lightModeSelector">
        <app-weave-radio-group
          [label]="'VIEW'"
          [radioList]="lightOptions"
          [data]="lightMode"
          [showOptionsVertical]="true"
          (changed)="changeLightMode($event)"
        ></app-weave-radio-group>
      </li>
      -->
      @if (isImpersonatedUser) {
        <li class="withPadding">
          <a (click)="stopImpersonate(); toggleUserMenu()">
            <mat-icon fontSet="material-icons-outlined">person_off</mat-icon>
            <span class="pageHeader">Restore Account</span>
          </a>
        </li>
      }
      <li class="withPadding">
        <a (click)="logout()">
          <mat-icon fontSet="material-icons-outlined">logout</mat-icon>
          <span class="pageHeader">Sign Out</span>
        </a>
      </li>
    </ul>
  }
</div>
